// Utility to parse date strings without timezone issues
// When parsing "2026-03-21", we want March 21st in local time, not UTC

export const parseLocalDate = (dateStr) => {
  // Split the date string and create date in local timezone
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day); // month is 0-indexed
};

export const formatDate = (dateStr, options = {}) => {
  const date = parseLocalDate(dateStr);
  const defaultOptions = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    ...options
  };
  return date.toLocaleDateString('en-US', defaultOptions);
};

export const formatShortDate = (dateStr) => {
  const date = parseLocalDate(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

export const getDateParts = (dateStr) => {
  const date = parseLocalDate(dateStr);
  return {
    day: date.getDate(),
    month: date.toLocaleDateString('en-US', { month: 'short' }),
    monthLong: date.toLocaleDateString('en-US', { month: 'long' }),
    year: date.getFullYear()
  };
};
